<template>
    <div class="main-layout">
      <a href="#main-content" class="skip-link">{{ $t('Skip to content') }}</a>
      <notifications></notifications>
      <navigation></navigation>
      <VideoExportStatus />
      <AiToolsGlobal />
      <OpeningOverlay />
        <main id="main-content" :class="[
          'layout-content',
          isDesktop ? 'pt-16' : 'pt-2',
          !isDesktop && !editorOpen ? 'pb-24' : ''
        ]" >
          <router-view></router-view>
        </main>
      <ConsentBanner v-if="currentMode != 'productionradio'" />
    </div>
</template>
<script>
import { computed } from 'vue';
import { Capacitor } from '@capacitor/core';
import ConsentBanner from './components/ConsentBanner.vue';
import Navigation from './components/Navigation.vue';
import VideoExportStatus from './components/SrtEditor/VideoExportStatus.vue';
import AiToolsGlobal from './components/AiTools/AiToolsGlobal.vue';
import OpeningOverlay from './components/OpeningOverlay.vue';
import { useTranscriptEditor } from './components/SrtEditor/useTranscriptEditor';
import { useThemeStore } from '@stores/themeStore';
import { storeToRefs } from 'pinia';

export default {
  name: 'App',
  components: {
    ConsentBanner,
    Navigation,
    VideoExportStatus,
    AiToolsGlobal,
    OpeningOverlay,
  },
  setup() {
    const currentMode = import.meta.env.MODE;
    const themeStore = useThemeStore();
    const { isDarkMode } = storeToRefs(themeStore);
    const editor = useTranscriptEditor();
    const editorOpen = computed(() => editor.showSrtEditor.value);
    
    const isNativePlatform = computed(() => __IS_NATIVE__);
    const isDesktop = computed(() => !isNativePlatform.value && window.innerWidth >= 1024);
    
    return {
      isNativePlatform: __IS_NATIVE__,
      isDesktop,
      isDarkMode,
      editorOpen,
      currentMode
    };
  }
};
</script>
<style lang="scss">
@import '@/assets/css/tokens.css';
@import '@/assets/scss/theme-variables.scss'; /* shim — re-exports tokens.css */

.skip-link {
  position: absolute;
  top: -100%;
  left: 8px;
  z-index: 10000;
  padding: 8px 16px;
  background: var(--adm-accent, #4f46e5);
  color: #fff;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
}
.skip-link:focus {
  top: 8px;
}

.main-layout {
  min-height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  transition: background-color 0.3s ease, color 0.3s ease;
}


.layout-content {
  flex: 1;
  width: 100%;
  height: 100%;
}

.native-spacing {
  margin-top: 40px; // Adjust this value as needed
}

.vue-notifyjs.notifications {
  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }
  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }
  .list-enter {
    opacity: 0;
    transform: scale(1.1);
  }
  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
}

/* Global theme transitions */
body, button, input, select, textarea {
  transition: background-color 0.3s, color 0.3s, border-color 0.3s;
}

/* Shared sizing for the visible SRT editor toolbars: save/revert/case/actions
   and both zoom-control groups use one exact control height. */
.srt-control-button {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 30px !important;
  min-height: 30px;
  padding: 4px 8px !important;
  font-size: 0.85rem !important;
  line-height: 1 !important;
  white-space: nowrap;
}

/* Theme tokens are defined in @/assets/css/tokens.css — do not duplicate :root here. */


</style>
